<template>
  <v-container>
    About ...
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
      }
    },

    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/User/About.vue